<template>
  <ion-page id="signin-page">
    <ion-content>

      <div v-show="showState == SHOW_EXPLAINTOUR">
        <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />
      </div>

      <div v-show="showState == SHOW_REGISTER">
        <TopLine :style="styleTopline" :title="registerTitleString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

        <div :style="styleMiddle">

          <ion-item>
            <h5>{{ message }}</h5>
          </ion-item>

          <div v-if="showEmailPassword">

            <ion-item>
              <ion-input :label="emailString"  label-placement="fixed" 
                        :placeholder="emailPlaceholderString"  :value="email"
                        @ionInput="emailInputChange">
              </ion-input>
            </ion-item>

            <ion-item>
              <ion-input :label="passwordString" type="password" label-placement="fixed" 
                        :placeholder="passwordPlaceholderString" :value="password"
                        @ionInput="passwordInputChange">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-item>

            <ion-item>
              <ion-input :label="passwordString"  type="password" label-placement="fixed" 
                        :placeholder="passwordPlaceholderString" :value="password2"
                        @ionInput="password2InputChange">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-item>
          </div>
        </div>
        <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </div>
    </ion-content>
  </ion-page>
  

</template>

<script setup>

  import { IonCheckbox,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { ref , watch } from 'vue';
  import ExplainTour from '@/components/ExplainTour.vue'
  import { useGetData , generateErrorAlertText } from '../../composables/getData.js'
  import { useConnectionStore } from '../../stores/connectionStore.js';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '../../composables/startupCheck.js'
  import ToolBar from '@/components/ToolBar.vue'
  import { parseWordsSaid } from '@/composables/wordlistSupport.js'
  import TopLine from '@/components/TopLine.vue'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, 
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation.js';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
        wordsSaid : {
          type : String,
          default : ""
        },
        wordsSaidTrigger : {
          type : Number,
          default : 0
        }
      })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const registerTitleString = ref(translateEnglishWords("Register"))
  const emailString = ref(translateEnglishWords("Email"))
  const passwordString = ref(translateEnglishWords("Password"))
  const emailPlaceholderString = ref(translateEnglishWords("Enter email"))
  const passwordPlaceholderString = ref(translateEnglishWords("Enter password"))

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)

  const isDark = ref(connectionStore.getDarkmode != "light")

  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  // if user is logged in, go to home screen
  if (cookie != "" && dummy == 0) {
    emit("where-next","/")
  }

  const email = ref("")
  const password = ref("")
  const password2 = ref("")

  const message = ref(translatePhrase("Please Register"))
  const showEmailPassword = ref(true)

  const wordlistRegister = "command register done ignore mute listen"
  const wordlist = ref(wordlistRegister)
  emit("word-list",wordlistRegister)

  const wordlistTrigger = ref(0)

  const TOOLBAR_REGISTER = 0
  const TOOLBAR_EXPLAIN = 1

  const toolbarElements = ref([
    { index : TOOLBAR_REGISTER, label : translateEnglishWords("Register") ,disabled : false},
  ])
  const toolbarTrigger = ref(0)

  const SHOW_REGISTER = 0
  const SHOW_EXPLAINTOUR = 1
  const showState = ref(SHOW_REGISTER)

  const explainTitle = ref("")
  const explainMessage = ref("")
  
  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

  watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

     // START Explain Tour Routines

 function explainTourInitialize(pageName,errorText) {
    //console.log("in explain tour initialize,errorText")
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? "register" : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

function explainTourToolbarClick(whatClicked) {
    function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_REGISTER
        wordlist.value = wordlistRegister
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        break
    }
  }

}

// END Explain Tour Routines

function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }
  
  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_REGISTER :
        processWords("command register")
        break
    }
  }

  function processWords(text) {
    //console.log("text in Logoff ",text)
    const returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
        case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        emit("where-next","/accountmenu")
        //router.replace({ path: "/accountmenu"})
        break
      case "register" :
        doRegister()
        break
    }
  }

   function emailInputChange(ev) {
    //console.log("email ",ev)
    const value = ev.target.value;
    ///console.log("email",value)
    email.value = value.trim()
  }

  function passwordInputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password.value = value.trim()
  }

    function password2InputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password2.value = value.trim()
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore")
          return ["ignore",""];
        if (currentWord == "done" || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""]
        if (currentWord == "register")
          return ["register",""]

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
  }

  function processJsonResponse (json) {
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(null,generateErrorAlertText(json))
      return;
    }
    switch (json['stat']) {
      case 'g' :
        const cookie = json['cookie']
        connectionStore.setUserCookieDummy(cookie,"0")
        connectionStore.setEmailAddress(email.value)
  
        emit("where-next","/main_from_register")

        break
      default :
        message.value = translatePhrase("Email is already in the system. Please Login")
        break;
    }
  }

  function doRegister () {
    if (email.value == "") {
      message.value = translatePhrase("Please enter your email address")
      return
    }
    if (password.value == "") {
      message.value = translatePhrase("Please enter your password")
      return
    }
    if (password2.value != password.value) {
      message.value = translatePhrase("Passwords don't match")
      return
    }
    message.value = translateEnglishWords("registering") + "...."
    var formData = { e : email.value , p: password.value }
    useGetData("mobile_register.php", formData, processJsonResponse)
  }

</script>

<style scoped>

ion-item {
  margin:10px;
}

</style>